import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { buildSummaryRequest } from "../../../state/connect-api";
import { useGetCasePriorsMutation } from "../../../state/globalApi";
import { updateCaseMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import getConfigs from "../../../GetConfigs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CasePriors = () => {
  const { activeCaseNumber, caseMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getCasePriors] = useGetCasePriorsMutation();
  const [messageVisible, setMessageVisible] = useState<boolean>(true)
  const configurations = getConfigs([
    "ctTRCRPriorsTxt",
  ]);

  useEffect(() => {
    const lookupRequest = buildSummaryRequest(activeCaseNumber);
    const fetch = async () => {
      const priors = await getCasePriors(lookupRequest).unwrap();
      dispatch(updateCaseMaster({ priors: priors }));
    };

    fetch();
  }, [activeCaseNumber, dispatch, getCasePriors]);
  return (
    <Row gutter={[16, 16]}>
      {configurations.ctTRCRPriorsTxt && messageVisible && (
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          <Card>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
            </div>
            <br />
            <div dangerouslySetInnerHTML={{ __html: configurations.ctTRCRPriorsTxt }} />
          </Card>
        </Col>
      )}
      <Col xl={24} lg={24} md={24} sm={24} xs={24}></Col>
    </Row>
  );
};

export default CasePriors;
